(() => {
  let l = (e) => {
      var t = e.querySelector(".multicolumn-list__wrapper"),
        s = e.querySelectorAll(".multicolumn-list__item");
      e.classList.add("swiper"),
        t && t.classList.add("swiper-wrapper"),
        s.forEach((e) => {
          e.classList.add("swiper-slide");
        });
    },
    t = (e) => {
      var t = e.querySelector(".multicolumn-list__wrapper"),
        s = e.querySelectorAll(".multicolumn-list__item");
      e.classList.remove("swiper"),
        t && t.classList.remove("swiper-wrapper"),
        s.forEach((e) => {
          e.removeAttribute("style"), e.classList.remove("swiper-slide");
        });
    },
    s = (e) => {
      var t,
        s,
        i,
        r,
        e = e.querySelector(".swiper--multicolumn:not(.swiper-initialized)");
      e &&
        (l(e),
        (t = Number(e.dataset.mobileColumns) || 1),
        (i = 4 === (s = Number(e.dataset.desktopColumns) || 1) ? s - 1 : s),
        (r = 2 < s ? i - 1 : s),
        new Swiper(e, {
          loop: !1,
          speed: 800,
          slidesPerView: t,
          slidesPerGroup: t,
          spaceBetween: 8,
          mousewheel: { forceToAxis: !0 },
          breakpoints: {
            750: { slidesPerView: r, slidesPerGroup: r, spaceBetween: 24 },
            990: { slidesPerView: i, slidesPerGroup: i, spaceBetween: 24 },
            1360: { slidesPerView: s, slidesPerGroup: s, spaceBetween: 24 },
          },
          pagination: {
            el: e.querySelector(".multicolumn__pagination"),
            clickable: !1,
            type: "custom",
            renderCustom: function (e, t, s) {
              let i = "";
              for (let e = 1; e < s + 1; e++)
                i =
                  e == t
                    ? `${i}<span class="swiper-pagination-bullet swiper-pagination-bullet-active" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`
                    : `${i}<span class="swiper-pagination-bullet" tabindex="0" role="button" aria-label="Go to slide ${e}"></span>`;
              return i;
            },
          },
        }));
    },
    i = (e) => {
      e = e.querySelector(".swiper--multicolumn");
      e && (e.swiper && e.swiper.destroy(), t(e));
    },
    r = (e) => {
      if (e && e.classList.contains("multicolumn-section")) {
        let t = e.querySelector(".swiper--multicolumn");
        t &&
          new ResizeObserver((e) => {
            e.forEach((e) => {
              ("true" != t.dataset.sliderMobile ||
                "true" != t.dataset.sliderDesktop
                ? e.contentRect.width < 576
                  ? "true" == t.dataset.sliderMobile
                    ? s
                    : i
                  : "true" == t.dataset.sliderDesktop
                    ? s
                    : i
                : s)(e.target);
            });
          }).observe(e);
      }
    };
  r(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      r(e.target);
    });
})();
